import { render, staticRenderFns } from "./EntityCard.vue?vue&type=template&id=2d10bf2b&scoped=true&"
import script from "./EntityCard.vue?vue&type=script&lang=js&"
export * from "./EntityCard.vue?vue&type=script&lang=js&"
import style0 from "./EntityCard.vue?vue&type=style&index=0&id=2d10bf2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10bf2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
